export const navItems = [
  { title: "Fleet", href: "/vehicles" },
  { title: "Features", href: "/#features", isHashLink: true },
  { title: "FAQs", href: "/#faqs", isHashLink: true },
];
